﻿import React, { useState, useEffect } from 'react';
import { BenchSheetTechnologyType, CalculatorTypes } from '../../models/enums';
import { LookupItem } from '../../models/lookup-item';
import { ProductBatchListItem } from '../../models/product-batch-list-item';
import { BenchSheetListItem } from '../../models/bench-sheet-list-item';

//import { Calculator } from '../../models/Calculators/calculator';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import CreateQnmrCalculatorComponent from './CreateQnmrCalculatorComponent';
import CreateHplcMassSpecCalculatorComponent from './CreateHplcMassSpecCalculatorComponent';

//import TextBox from 'devextreme-react/text-box';

import DataGrid, {
    Column,
    Selection,
    HeaderFilter,
    Toolbar,
    Item as ToolbarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import SelectBox from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';

export interface Props {
    batch: ProductBatchListItem;
    onClose?: () => void;
    onCancel?: () => void;
}

export default function CreateCalculatorComponent(props: Props) {
    const [calculatorTypes, setCalculatorTypes] =
        useState<LookupItem[]>();

    const [selectedCalculatorType, setSelectedCalculatorType] =
        useState<CalculatorTypes>();

    const [benchSheets, setBenchSheets] =
        useState<BenchSheetListItem[]>();

    const [selectedBenchSheet, setSelectedBenchSheet] =
        useState<BenchSheetListItem>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, []);

    useEffect(() => {
        getBenchSheetsByTechnology();
    }, [selectedCalculatorType]);

    return (
        <div>
            <div className="pw-comp-row">
                <div className="pw-form-unit pw-comp-20">
                    <div className="pw-form-unit-label">Batch Name</div>
                    <div className="lq-header-3 pw-blue">{props.batch && props.batch.batchName ?
                        props.batch.batchName : undefined}</div>
                </div>
            </div>

            <div className="pw-comp-row pw-margin-top-05">
                <div className="pw-form-unit pw-comp-20">
                    <div className="pw-form-unit-label">Calculator Type</div>
                    <SelectBox id="calculatorType" className="textbox"
                        showClearButton={true}
                        dataSource={calculatorTypes ? calculatorTypes : []}
                        displayExpr='name' valueExpr='id'
                        onValueChanged={onCalculatorTypeValueChanged}
                        placeholder="calculator type" value={selectedCalculatorType ?
                            selectedCalculatorType : undefined} />
                </div>
            </div>

            <div>
                <DataGrid
                    height="10rem"
                    keyExpr="benchSheetId"
                    wordWrapEnabled={true}
                    rowAlternationEnabled={true}
                    onSelectionChanged={onBenchSheetsDatagridSelectionChanged}
                    dataSource={benchSheets ? benchSheets : []}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Selection mode='single' />
                    <HeaderFilter visible={true} />

                    <Column dataField='batchName' width='50%' />
                    <Column dataField='catalogNumber' width='50%' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Bench Sheets</div>
                            </div>
                        </ToolbarItem>
                    </Toolbar>
                </DataGrid>
            </div>

            {selectedCalculatorType === CalculatorTypes.HplcMassSpec &&
                <CreateHplcMassSpecCalculatorComponent batch={props.batch}
                    onApply={applyNewHplcMassSpecCalculatorCreated} />
            }

            {selectedCalculatorType === CalculatorTypes.Qnmr &&
                <CreateQnmrCalculatorComponent batch={props.batch}
                    onApply={applyNewQnmrCalculatorCreated} />
            }

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="createCalculatorButton" text="Create" icon="plus" type="success"
                        className="pw-button"
                        hint="create new calculator"
                        onClick={onCreateNewCalculatorClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function onCalculatorTypeValueChanged(e: any) {
        setSelectedCalculatorType(e.value);        
    }

    function getBenchSheetsByTechnology() {
        if (props.batch && props.batch.batchId && selectedCalculatorType) {

            let technologyId;

            switch ( selectedCalculatorType) {
                case CalculatorTypes.MultiComponentMasterAssay:
                    //todo
                    break;

                case CalculatorTypes.Neat:
                    //todo
                    break;

                case CalculatorTypes.Qnmr:
                    technologyId = BenchSheetTechnologyType.QNuclearMagneticResonance;
                    break;

                case CalculatorTypes.HplcMassSpec:
                    technologyId = BenchSheetTechnologyType.HighPerformanceLiquidChromatography;
                    break;
            }

            if(technologyId)
                getBenchSheets(props.batch.batchId, technologyId);
        }
    }

    function onBenchSheetsDatagridSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedBenchSheet(e.selectedRowsData[0]);
        }
    }

    function onCreateNewCalculatorClick() {
        if (props.batch && props.batch.batchId && selectedCalculatorType) {
            findOrCreateNewCalculator(props.batch.batchId)
                .then(() => {
                    if (props.onClose)
                        props.onClose();
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Finding/Creating New Calculator");
                });
        }
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    async function getCalculatorTypes() {
        await CrudFunctions.getData("calculator/calculatortypes")
            .then((data) => {
                setCalculatorTypes(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Calculator Types");
            });
    }

    async function getBenchSheets(batchId: string, technologyId: number) {
        await CrudFunctions.getData(`benchsheets/benchsheetsbybatchid/${batchId}/${technologyId}`)
            .then((data) => {
                setBenchSheets(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Bench Sheets");
            });
    }

    async function findOrCreateNewCalculator(batchId: string) {
        if (batchId)
            return await CrudFunctions.getData(`calculator/findorcreate/${batchId}/${selectedCalculatorType}`)
    }

    async function getAllData() {
        await getCalculatorTypes();
    }

    function applyNewQnmrCalculatorCreated() {

    }

    function applyNewHplcMassSpecCalculatorCreated() {

    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}

